import React, { useEffect, useState } from 'react'
import { useStyles } from './FormRattachementEnfantsStyle'
import { useSnackbar } from 'notistack'
import FilePicker from '../FilePicker/FilePicker'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../../../redux/actions/user'



//Material UI
import Button from '@material-ui/core/Button'
import DeleteIcon from '@material-ui/icons/Delete'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import IconButton from '@material-ui/core/IconButton'
import TabNavigation from '../../TabNavigation/TabNavigation'
import Chip from '@material-ui/core/Chip'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import AttachmentIcon from '@material-ui/icons/Attachment'
import MenuItem from '@material-ui/core/MenuItem'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import { Divider, FormControl, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormHelperText } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'

export default function FormRattachementEnfants(props) {

  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()
  const { formClass, defaultValues, liensQualite, refresh, id, previousTab } = props

  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''


  const { register, handleSubmit, errors, control } = useForm({
    defaultValues: {
      nom: '',
      prenom: '',
      centre: '',
      datenaiss: null,
      civilite: null,
      contacts: [
        {
          CONTURG_NOM: '',
          CONTURG_PRENOM: '',
          CONTURG_TELPORTABLE: '',
          CONTURG_LIENQUAL_ID: '',
        },
        {
          CONTURG_NOM: '',
          CONTURG_PRENOM: '',
          CONTURG_TELPORTABLE: '',
          CONTURG_LIENQUAL_ID: '',
        }
      ]
    }
  })

  /**
   * save justificatif
   * @param {*} e event form
   */
  async function save(e) {
    e.preventDefault()

    const data = { justificatif, category: 5 }
    const result = await allActions.fetchPostAPI(`api/users/modifs-infos-perso/${id}`, data, dispatch, token)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
      return
    }

    //Si le serveur retourne une erreur elle est affiché
    if (result?.json.err) {
      enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
      return
    }

    enqueueSnackbar('Enregistré !', { variant: `success` })
    refresh(result.json.data)

    const action = e.nativeEvent.submitter.dataset.action
    if (action === 'previous' && previousTab) previousTab()
  }

  const [enfantsWaiting, setenfantsWaiting] = useState(defaultValues.waitingEnfants)
  const [enfantsRattaches, setenfantsRattaches] = useState(defaultValues.enfantsRattache)
  const [deleteDialog, setdeleteDialog] = useState(false)
  const [enfantDialog, setenfantDialog] = useState({})

  async function lierEnfant(e) {

    e.preventDefault()

    const data = { numeroEnfant: e.target['numero'].value }
    if (data.numeroEnfant === state.user.numero) return enqueueSnackbar('Erreur: Vous ne pouvez pas vous ajouter vous même 🤷', { variant: `error` })
    const result = await allActions.fetchPostAPI(`api/users/rattacher-enfant/${id}`, data, dispatch, token)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
      return
    }

    if (result.json.data) refresh(result.json.data)

    //Si le serveur retourne une erreur elle est affiché
    if (result?.json.err) {
      enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
      return
    }

    enqueueSnackbar(result.json.message, { variant: `success` })
    setDialogLierEnfant(false)
  }

  async function creerEnfant(data) {

    data = { ...data, email: state.user.mail }

    const result = await allActions.fetchPostAPI(`api/users/creer-enfant/${id}`, data, dispatch, token)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
      return
    }

    refresh(result.json.data)

    //Si le serveur retourne une erreur elle est affiché
    if (result?.json.err) {
      enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
      return
    }

    enqueueSnackbar(result.json.message, { variant: `success` })
    
    setDialogCreerEnfant(false)

  }

  useEffect(async() => {
    setenfantsRattaches(defaultValues.enfantsRattache)
    setenfantsWaiting(defaultValues.waitingEnfants)
  }, [defaultValues])

  useEffect(async() => {
    try {
      const res = await getCenter()
      if (res.err) {
        console.log('ERR: ' + res.err)
        enqueueSnackbar('Erreur: ' + res.err, { variant: `error` })
        return
      }

      setCentres(res.json)
    } catch (e) {
      console.log(e)
    }

  }, [])

  async function detacherEnfantFetch(idEnfant) {

    const data = { idEnfant }
    const result = await allActions.fetchPostAPI(`api/users/detacher-enfant/${id}`, data, dispatch, token)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
      return
    }

    if (result.json.data) refresh(result.json.data)

    //Si le serveur retourne une erreur elle est affiché
    if (result?.json.err) {
      enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
      return
    }

    setenfantsRattaches(enfantsRattaches.filter(e => e.LICI_ID !== idEnfant))
    enqueueSnackbar(result?.json?.message, { variant: `success` })

    setdeleteDialog(false)
    setenfantDialog({})

  }

  function detacherEnfantModale(idEnfant) {
    const enfant = enfantsRattaches.find(e => e.LICI_ID === idEnfant)
    setenfantDialog(enfant)
    setdeleteDialog(true)
  }

  const [justificatif, setJustificatif] = useState(defaultValues.justificatif ?? '')
  function fileChanged(file) {
    setJustificatif(file)
  }

  const [dialogLierEnfant, setDialogLierEnfant] = useState(false)
  const [dialogCreerEnfant, setDialogCreerEnfant] = useState(false)
  const [selectedCentre, setSelectedCentre] = useState('')
  const [selectedDate , setSelectedDate] = useState(null)
  const [centres, setCentres] = useState([])
  const minDatePicker = new Date() 
  minDatePicker.setFullYear(minDatePicker.getFullYear() - 18)
  
  /**
   * Get all centers
   */
  function getCenter() {
    dispatch(allActions.setLoading(true))
    return new Promise(async (resolve) => {
      try {
        const url = 'api/center'
        const res = await fetch(process.env.REACT_APP_API_PATH + url, {
          method: 'get',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        const json = await res.json()
        resolve({ res: res, json: json })
      } catch (err) {
        resolve({ err: 'Service non disponible' })
      } finally {
        dispatch(allActions.setLoading(false))
      }
    })
  }

  useEffect(async() => {
    setSelectedCentre('')
    setSelectedDate(null)
  }, [dialogCreerEnfant])

    
  return (
    <div>
      <form onSubmit={save}>
        <div className={formClass}>

          <div className={classes.line} >
            <FilePicker
              onChange={fileChanged}
              defaultValue={defaultValues.justificatif}
              fileDownloadName="justificatif"
              inputLabel="Ajouter un justificatif (livret de famille)"
            />

            {/* form ajout d'enfant */}
            <div className={classes.ajout} >
              <p>Ajouter un enfant:</p>
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  startIcon={<AddCircleIcon />}
                  style={{ height: 40, width: 200, alignItems: 'center' }}
                  onClick={() => {setDialogCreerEnfant(true)}}
                >Créer</Button>
                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  startIcon={<AttachmentIcon />}
                  style={{ height: 40, width: 200 }}
                  onClick={() => {setDialogLierEnfant(true)}}
                >Lier</Button>
                
              </div>

            </div>

          </div>

          {/* enfants en attente de validation */}
          {enfantsWaiting.length !== 0 &&
          <div className={classes.waitingList}>
            <p>En attente:</p>
            <div>
              {enfantsWaiting.map((e, i) =>
                (<Chip
                  key={i}
                  label={e.LICI_NUMERO}
                  onDelete={() => detacherEnfantFetch(e.LICI_ID)}
                />)
              )}
            </div>
          </div>
          }

          {/* enfants Rattachés */}
          {enfantsRattaches.length !== 0 &&
          <div className={classes.rattachesList}>
            <p>Enfants rattachés:</p>
            <div>
              <TableContainer>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>N° abonne</TableCell>
                      <TableCell>Nom</TableCell>
                      <TableCell>Prenom</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {enfantsRattaches.map((row) => (
                      <TableRow key={row.LICI_ID}>
                        <TableCell>{row.LICI_NUMERO}</TableCell>
                        <TableCell>{row.LICI_NOM}</TableCell>
                        <TableCell>{row.LICI_PRENOM}</TableCell>
                        <TableCell align="right">
                          <IconButton
                            onClick={() => detacherEnfantModale(row.LICI_ID)}
                            size="small">
                            <DeleteIcon fontSize="small"></DeleteIcon>
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          }



        </div>


        <TabNavigation save previous next />

      </form>

      <Dialog open={deleteDialog} onClose={() => setdeleteDialog(false)} >
        <DialogContent>
          <DialogContentText style={{ paddingTop: '16px', color: 'black' }}>
             Voulez vous vraiment détacher l'enfant <b>{enfantDialog.LICI_NOM} {enfantDialog.LICI_PRENOM}</b> ?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={() => setdeleteDialog(false)} style={{ color: 'red' }}>
            Annuler
          </Button>
          <Button onClick={() => detacherEnfantFetch(enfantDialog.LICI_ID)} color="primary" autoFocus>
            Détacher
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dialogLierEnfant} onClose={() => {setDialogLierEnfant(false)}} >
        <form onSubmit={lierEnfant}>
          <DialogTitle >Lier un enfant</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Vous pouvez lier un enfant ayant déjà un compte avec son numéro d'abonné.
            </DialogContentText>
            <TextField
              label="N° abonne"
              variant="outlined"
              size="small"
              fullWidth
              name="numero"
              autoFocus
              required
            />
          </DialogContent>
          <DialogActions className={classes.actions}>
            <Button onClick={() => {setDialogLierEnfant(false)}} className={classes.cancel}>
              Annuler
            </Button>
            <Button type="submit" color="primary" >
              Lier
            </Button>
          </DialogActions>
        </form>

      </Dialog>

      <Dialog open={dialogCreerEnfant} onClose={() => {setDialogCreerEnfant(false)}} >
        <form onSubmit={handleSubmit(creerEnfant)}>
          <DialogTitle >Créer un enfant</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Vous pouvez créer un enfant directement lié à votre compte en remplissant ces informations.
            </DialogContentText>

            <h4 style={{ marginBlock: 8 }}>Information de l'enfant</h4>
            <div className={classes.wrap}>
              <TextField
                size="small"
                variant="outlined"
                label="Nom"
                type="text"
                margin="dense"
                inputRef={register}
                name="nom"
                
                required
              />
              <TextField
                size="small"
                variant="outlined"
                label="Prenom"
                inputRef={register}
                name="prenom"
                type="text"
                margin="dense"
                
                required
              />
              <FormControl {...register('centre')} style={{
                display: 'block',
                height: '-webkit-fill-available',
                marginTop: '8px',
                marginBottom: '4px',
              }}>
                <Controller
                  as={
                    <TextField
                      select
                      label={'Centre'}
                      size="small"
                      required
                    >
                      {centres.map((c, i) => (<MenuItem value={c.id} key={i}>{c.libelle} </MenuItem>))}
                    </TextField>
                  }
                  name={'centre'}
                  control={control}
                  
                    
                />
              </FormControl>

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Controller
                  name="datenaiss"
                  control={control}
                  render={({ ref, ...rest }) => (
                    <KeyboardDatePicker
                      required
                      margin="dense"
                      label="Date de naissance"
                      format="dd/MM/yyyy"
                      inputVariant="outlined"
                      disableFuture
                      {...rest}
                    />
                  )}
                />
              </MuiPickersUtilsProvider>
                
              <FormControl >
                <Controller
                  rules={{ required: true }}
                  control={control}
                  name="civilite"
                  as={
                    <RadioGroup className={classes.radio}>
                      <FormLabel style={{ marginRight: 16 }}>Civilité *</FormLabel>

                      <FormControlLabel value="M." control={<Radio required color='primary' />} label="M." />
                      <FormControlLabel value="Mme" control={<Radio required color='primary' />} label="Mme" />
                      
                    </RadioGroup>
                  }
                />
              </FormControl>
            </div>

            <Divider sx={{ marginBlock: 2 }}/>
            
            <div className={classes.columns}>
              <div>
                <h4 style={{ marginBlock: 0 }}>1er contact d'urgence</h4>
                <TextField
                  label="Nom"
                  className={classes.name}
                  variant="outlined"
                  type="text"
                  name="contacts.0.CONTURG_NOM"
                  margin="dense"
                  inputRef={register}
                  size="small"
                  fullWidth
                  required
                />

                <TextField
                  label="Prénom"
                  className={classes.name}
                  variant="outlined"
                  type="text"
                  name="contacts.0.CONTURG_PRENOM"
                  margin="dense"
                  inputRef={register}
                  size="small"
                  fullWidth
                  required
                />

                <div>

                  <TextField
                    label="Téléphone"
                    variant="outlined"
                    type="number"
                    name="contacts.0.CONTURG_TELPORTABLE"
                    margin="dense"
                    inputRef={register({ minLength: 10, maxLength: 10, })}
                    error={(errors.CONTURG_TELPORTABLE !== undefined)}
                    size="small"
                    fullWidth
                    required
                  />
                  {errors.contacts && errors.contacts[0]?.CONTURG_TELPORTABLE && <FormHelperText error>Le numéro doit contenir 10 chiffres</FormHelperText>}
                </div>


                <FormControl {...register('contacts.0.CONTURG_LIENQUAL_ID')} style={{
                  display: 'block',
                  height: '-webkit-fill-available',
                  marginTop: '8px',
                  marginBottom: '4px',
                }}>
                  <Controller
                    as={
                      <TextField
                        select
                        label={'Lien'}
                        size="small"
                        fullWidth
                      >
                        {liensQualite.map((l, i) => (<MenuItem value={l.id} key={i}>{l.libelle} </MenuItem>))}
                      </TextField>
                    }
                    name={'contacts.0.CONTURG_LIENQUAL_ID'}
                    control={control}
                    fullWidth
                    required
                  />
                </FormControl>
              </div>
              
                
              <Divider orientation='vertical' flexItem />

              <div>
                <h4 style={{ marginBlock: 0 }}>2eme contact d'urgence</h4>
                <TextField
                  label="Nom"
                  className={classes.name}
                  variant="outlined"
                  type="text"
                  name="contacts.1.CONTURG_NOM"
                  margin="dense"
                  inputRef={register}
                  size="small"
                  fullWidth
                  required
                />

                <TextField
                  label="Prénom"
                  className={classes.name}
                  variant="outlined"
                  type="text"
                  name="contacts.1.CONTURG_PRENOM"
                  margin="dense"
                  inputRef={register}
                  size="small"
                  fullWidth
                  required
                />

                <div>

                  <TextField
                    label="Téléphone"
                    variant="outlined"
                    type="number"
                    name="contacts.1.CONTURG_TELPORTABLE"
                    margin="dense"
                    inputRef={register({ minLength: 10, maxLength: 10, })}
                    error={(errors.CONTURG_TELPORTABLE !== undefined)}
                    size="small"
                    fullWidth
                    required
                  />
                  {errors.contacts && errors.contacts[1]?.CONTURG_TELPORTABLE && <FormHelperText error>Le numéro doit contenir 10 chiffres</FormHelperText>}
                </div>


                <FormControl {...register('contacts.1.CONTURG_LIENQUAL_ID')} style={{
                  display: 'block',
                  height: '-webkit-fill-available',
                  marginTop: '8px',
                  marginBottom: '4px',
                }}>
                  <Controller
                    as={
                      <TextField
                        select
                        label={'Lien'}
                        size="small"
                        fullWidth
                        required
                      >
                        {liensQualite.map((l, i) => (<MenuItem value={l.id} key={i}>{l.libelle} </MenuItem>))}
                      </TextField>
                    }
                    name={'contacts.1.CONTURG_LIENQUAL_ID'}
                    control={control}
                  />
                </FormControl>
              </div>
              
            </div>
            
            

          </DialogContent>
          <DialogActions className={classes.actions}>
            <Button onClick={() => {setDialogCreerEnfant(false)}} className={classes.cancel}>
              Annuler
            </Button>
            <Button type="submit" color="primary">
              Créer
            </Button>
          </DialogActions>
        </form>
      </Dialog>

    </div>

  )
}
